module.exports = __webpack_public_path__ + "img/card_energychile_background.95954355.png";